/**
 * VESANBE size picker
 * Full replacement for assets/size-unit-switcher.js
 *
 * The visible EU / US W / US M chips are display controls. Shopify still
 * receives the real EU radio value, so inventory and variant IDs stay intact.
 */
(function () {
  'use strict';

  var UNITS = ['EU', 'USW', 'USM'];
  var STORAGE_KEY = 'vb_size_unit';
  var state = {
    unit: 'EU',
    root: null,
    fieldset: null,
    display: null,
    propUnit: null,
    propSize: null,
    variantMap: null,
    syncQueued: false,
    delegated: false
  };

  function getRoot() {
    return document.querySelector('[data-vb-size-root]');
  }

  function getFieldset() {
    return document.querySelector('[data-vb-size-fieldset]');
  }

  function readUnit() {
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      return UNITS.indexOf(saved) !== -1 ? saved : 'EU';
    } catch (error) {
      return 'EU';
    }
  }

  function saveUnit(unit) {
    try {
      sessionStorage.setItem(STORAGE_KEY, unit);
    } catch (error) {}
  }

  function checkedEu() {
    if (!state.fieldset) return '';
    var checked = state.fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  }

  function activeChip() {
    return document.querySelector('[data-vb-size-root] .vb-size-chip--active');
  }

  function visibleEu() {
    var chip = activeChip();
    return chip ? chip.dataset.eu : checkedEu();
  }

  function chipText(chip) {
    for (var index = 0; index < chip.childNodes.length; index += 1) {
      var node = chip.childNodes[index];
      if (node.nodeType === 3 && node.textContent.trim()) {
        return node.textContent.trim();
      }
    }
    return chip.textContent.trim();
  }

  function displaySizeFor(eu, unit) {
    var chips = document.querySelectorAll('.vb-size-chip[data-unit="' + unit + '"]');
    for (var index = 0; index < chips.length; index += 1) {
      if (chips[index].dataset.eu === eu) return chipText(chips[index]);
    }
    return eu;
  }

  function parseVariantMap() {
    var node = document.querySelector('[data-vb-variant-map]');
    if (!node) return null;
    try {
      var map = JSON.parse(node.textContent);
      return map && typeof map === 'object' ? map : null;
    } catch (error) {
      return null;
    }
  }

  function currentOptionKey() {
    var parts = [];
    document.querySelectorAll('variant-selects fieldset').forEach(function (fieldset) {
      var value;
      if (fieldset.matches('[data-vb-size-fieldset]')) {
        value = visibleEu();
      } else {
        var checked = fieldset.querySelector('input:checked');
        value = checked ? checked.value : '';
      }
      if (value) parts.push(value);
    });
    return parts.join(' / ');
  }

  function expectedVariantId() {
    if (!state.variantMap) return null;
    var id = state.variantMap[currentOptionKey()];
    return id === undefined || id === null ? null : String(id);
  }

  function assertVariantId(form) {
    var expected = expectedVariantId();
    if (!expected) return;
    var scope = form && form.querySelectorAll ? form : document;
    scope.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = expected;
    });
  }

  function updateFitLine() {
    var line = document.querySelector('[data-vb-fit-line]');
    if (!line) return;
    var eu = visibleEu();
    if (!eu) {
      line.hidden = true;
      return;
    }

    var euNode = line.querySelector('[data-vb-fit-eu]');
    var messageNode = line.querySelector('[data-vb-fit-message]');
    var message = state.unit === 'EU'
      ? 'moulded into the footbed'
      : 'fits ' + (state.unit === 'USM' ? 'US M ' : 'US W ') + displaySizeFor(eu, state.unit);

    if (euNode) euNode.textContent = 'EU ' + eu;
    if (messageNode) messageNode.textContent = message;
    line.hidden = false;
  }

  function updateDisplay() {
    var eu = visibleEu();
    if (!eu) return;
    var display = state.unit === 'EU' ? eu : displaySizeFor(eu, state.unit);

    if (state.display) state.display.textContent = display;
    if (state.propUnit) state.propUnit.value = state.unit;
    if (state.propSize) state.propSize.value = display;
    updateFitLine();
  }

  function setActiveEu(eu) {
    document.querySelectorAll('[data-vb-size-root] .vb-size-chip').forEach(function (chip) {
      var active = chip.dataset.eu === eu;
      chip.classList.toggle('vb-size-chip--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function applyUnit(unit) {
    state.unit = UNITS.indexOf(unit) !== -1 ? unit : 'EU';
    saveUnit(state.unit);

    if (state.root) {
      state.root.querySelectorAll('.size-unit-btn').forEach(function (button) {
        var active = button.dataset.unit === state.unit;
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      state.root.querySelectorAll('.vb-size-panel').forEach(function (panel) {
        panel.hidden = panel.dataset.panel !== state.unit;
      });
    }

    updateDisplay();
  }

  function syncFromDawn() {
    if (!state.fieldset) return;

    state.fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var eu = input.value;
      var disabled = input.disabled || input.classList.contains('disabled');
      document.querySelectorAll('[data-vb-size-root] .vb-size-chip').forEach(function (chip) {
        if (chip.dataset.eu !== eu) return;
        chip.classList.toggle('vb-size-chip--disabled', disabled);
        chip.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    });

    var eu = checkedEu();
    var current = activeChip();
    if (!current || current.classList.contains('vb-size-chip--disabled')) setActiveEu(eu);
    updateDisplay();
    assertVariantId();
  }

  function queueSync() {
    if (state.syncQueued) return;
    state.syncQueued = true;
    requestAnimationFrame(function () {
      state.syncQueued = false;
      state.fieldset = getFieldset();
      state.variantMap = parseVariantMap();
      syncFromDawn();
    });
  }

  function selectEu(eu) {
    if (!state.fieldset || !eu) return;
    var target = null;
    state.fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.value === eu) target = input;
    });
    if (!target || target.disabled || target.classList.contains('disabled')) return;
    if (!target.checked) target.click();
    setActiveEu(eu);
    updateDisplay();
    assertVariantId();
  }

  function observeVariantSelects() {
    document.querySelectorAll('variant-selects').forEach(function (host) {
      if (host.dataset.vbObserver) return;
      host.dataset.vbObserver = 'true';
      new MutationObserver(queueSync).observe(host, { childList: true, subtree: true });
    });
  }

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = modal.querySelector('.size-guide-modal__close');
    if (close) close.focus();
  }

  function closeModal() {
    document.querySelectorAll('.size-guide-modal').forEach(function (modal) {
      modal.hidden = true;
    });
    document.body.style.overflow = '';
  }

  function moveModalsToBody() {
    ['size-guide-modal', 'size-unit-modal'].forEach(function (id) {
      var modal = document.getElementById(id);
      if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    });
  }

  function initEvents() {
    if (state.delegated) return;
    state.delegated = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      var unitButton = target.closest('[data-vb-size-root] .size-unit-btn');
      if (unitButton) {
        event.preventDefault();
        applyUnit(unitButton.dataset.unit);
        return;
      }

      var chip = target.closest('[data-vb-size-root] .vb-size-chip');
      if (chip) {
        event.preventDefault();
        if (!chip.classList.contains('vb-size-chip--disabled')) selectEu(chip.dataset.eu);
        return;
      }

      if (target.closest('.size-guide-trigger')) {
        event.preventDefault();
        openModal('size-guide-modal');
        return;
      }
      if (target.closest('.size-unit-help-trigger')) {
        event.preventDefault();
        openModal('size-unit-modal');
        return;
      }
      if (target.closest('.size-guide-modal__close') || target.closest('.size-guide-modal__overlay')) {
        event.preventDefault();
        closeModal();
      }
    }, true);

    document.addEventListener('variant:changed', queueSync);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    /* Correct the variant ID before Dawn or an app serializes the form. */
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector || !form.querySelector('input[name="id"]')) return;

      var chip = activeChip();
      if (chip && state.fieldset) {
        var eu = chip.dataset.eu;
        state.fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.checked = input.value === eu && !input.disabled;
        });
      }
      updateDisplay();
      assertVariantId(form);
    }, true);
  }

  function init() {
    state.root = getRoot();
    if (!state.root) return;
    state.fieldset = getFieldset();
    state.display = state.root.querySelector('[data-vb-size-display]');
    state.propUnit = state.root.querySelector('[data-vb-prop-unit]');
    state.propSize = state.root.querySelector('[data-vb-prop-size]');
    state.variantMap = parseVariantMap();
    moveModalsToBody();
    initEvents();
    applyUnit(readUnit());
    syncFromDawn();
    observeVariantSelects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
